export default __webpack_public_path__ + "static/media/experts3.d91f1442.jpg";